// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__j4HJS","header":"MessagesList_header__1-nXK","chat":"MessagesList_chat__173pM"};